import Vue from 'vue';
import Vuex from 'vuex';
import { injectAuthInterceptor } from '@/api/axios';
import auth from './modules/auth';
import favorites from './modules/favorites';
import hrDeveloper from './modules/hrDeveloper';
import hrDevelopers from './modules/hrDevelopers';
import hrProject from './modules/hrProject';
import hrProjects from './modules/hrProjects';
import hrRecruitment from './modules/hrRecruitment';
import hrCandidates from './modules/hrCandidates';
import hrIssue from './modules/hrIssue';
import hrIssues from './modules/hrIssues';
import notifications from './modules/notifications';
import issue from './modules/issue';
import issues from './modules/issues';
import project from './modules/project';
import developer from './modules/developer';
import projects from './modules/projects';
import recruitment from './modules/recruitment';
import survey from './modules/survey';
import password from './modules/password';
import general from './modules/general';
import features from './modules/features';
import attachment from './modules/attachment';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    favorites,
    hrDeveloper,
    hrDevelopers,
    hrProject,
    hrProjects,
    hrRecruitment,
    hrCandidates,
    hrIssue,
    hrIssues,
    issue,
    issues,
    notifications,
    developer,
    project,
    projects,
    recruitment,
    survey,
    password,
    general,
    features,
    attachment,
  },
});

injectAuthInterceptor(
  () => {
    store.dispatch('auth/logout');
  },
  () => {
    window.location = '/';
  },
);

export default store;
